<template>
    <div class="features">
        <feature-filters @update-filters="onUpdateFilters"  ref="filtersComponent"></feature-filters>
        <div class="feature-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} features</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
                <button @click="openModalEdit()" class="btn btn-outline-secondary btn-sm">Créer</button>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="features" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom" width="150"></el-table-column>
                <el-table-column prop="name" label="Nom Speedway" sortable="custom"></el-table-column>
                <el-table-column label="Nombre de valeur">
                    <template slot-scope="scope">
                        {{ scope.row.values.length }}
                    </template>
                </el-table-column>
                <el-table-column label="Actions" fixed="right" >
                    <template slot-scope="scope">
                        <a :title="scope.row.id" class="icon" @click="openModalEdit(scope.row)">
                            <i class="fe fe-edit"></i>
                        </a>
                        <a :title="scope.row.id" class="icon" @click="remove(scope.row)">
                            <i class="fe fe-trash-2 text-danger"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="'Modification ' + (modal.feature.name || '')" :visible.sync="modal.display" :fullscreen="true" v-loading="modal.loader" append-to-body>
            <feature-edit ref="featureEdit" :feature-id="modal.feature.id" :close-on-press-escape="false" :close-on-click-modal="false" ></feature-edit>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.display = false">Fermer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import Feature from '../../models/Feature';
export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'name',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'name',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            modal: {
                display: false,
                feature: {}
            },
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['features/totalItems'];
        },
        features() {
            return this.$store.getters['features/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        appendSearch() {
            return this.params['product_search'] ? ' '+this.params['product_search']+'&scope=name' : ''
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        this.$store.dispatch('app/setSearchMode', 'features');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    case 'product_search':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    default:
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        handleSelectionChange(val) {
            this.$store.dispatch('features/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('features/fetch', params).then(() => {
                this.loading = false;
            });
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(feature) {
            if( !feature ) {
                feature = new Feature;
            }
            this.modal.display = true;
            this.modal.feature = feature.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.features .feature-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        },
        remove(feature) {
            this.$confirm('Voulez-vous supprimer la feature', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios
                        .delete(
                            '/features/' +
                                feature.id
                        )
                        .then(r => {
                            this.fetch();
                        })
                        .catch(() => {})
                        .then(() => {
                        });
                })
                .catch((r) => {
                    //console.error(r);
                });
        },
    }
};
</script>
<style lang="scss">
.categories {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}
</style>
